module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "individual-student-ld-summary"
  }, [_c('div', {
    staticClass: "top-half flex-column-container"
  }, [_c('div', {
    staticClass: "name-and-avatar-container pl-headline"
  }, [_c('img', {
    staticClass: "student-avatar",
    attrs: {
      "src": _vm.getStudentSummaryLD.user.avatar_url,
      "alt": "student avatar"
    }
  }), _vm._v("\n      " + _vm._s(_vm.getStudentSummaryLD.user.name) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row no-margin middle-xs flex-grow"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('span', {
    staticClass: "turn-count col-xs-12 row middle-xs center-xs no-margin no-padding"
  }, [_vm._v("\n          " + _vm._s(_vm.total_times_spoken || 0) + "\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "times-spoken col-xs-12 no-padding no-margin"
  }, [_vm._v("\n          " + _vm._s(_vm.total_times_spoken === 1 ? 'Time' : 'Times') + " Spoken\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "applause-display-container pl-subheading"
  }, [_vm._v("\n          " + _vm._s(_vm.getStudentSummaryLD.applause_count) + " x 🙌 received\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6",
    staticStyle: {
      "padding-right": "2em"
    }
  }, _vm._l((_vm.hand_raise_types), function(count, type) {
    return _c('div', {
      staticClass: "row middle-xs center-xs"
    }, [_c('span', {
      staticClass: "col-xs-2 pl-bold"
    }, [_vm._v(_vm._s((count + "x")))]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-5 center-xs",
      class: (type + "-container")
    }, [_c('span', {
      staticClass: "capitalize"
    }, [_vm._v(_vm._s(type.split('_').join(' ')))])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "row no-margin button-row"
  }, [_c('div', {
    staticClass: "col-xs no-margin left-button",
    class: {
      'tab-selected': _vm.selected_tab === 'notes'
    },
    staticStyle: {
      "height": "40px"
    },
    on: {
      "click": function($event) {
        _vm.selected_tab = 'notes'
      }
    }
  }, [_c('span', [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs no-margin right-button",
    class: {
      'tab-selected': _vm.selected_tab === 'feedback'
    },
    staticStyle: {
      "height": "40px"
    },
    on: {
      "click": function($event) {
        _vm.selected_tab = 'feedback'
      }
    }
  }, [_c('span', [_vm._v("Feedback and Observation")])])]), _vm._v(" "), (_vm.selected_tab) ? _c('div', {
    staticClass: "start-xs bottom-half"
  }, [(_vm.selected_tab === 'notes') ? [_c('div', {
    staticClass: "content-card"
  }, [_c('div', {
    staticClass: "pl-subheading row between-xs no-padding",
    staticStyle: {
      "margin": "0 0 15px 0"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.getStudentSummaryLD.user.name.split(' ')[0]) + "'s notes from the\n          RoundTable\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "pl-body-1 white-spaced-text"
  }, [_vm._v("\n          " + _vm._s( // the curly brackets need to be next to tag because of white spacing
    _vm.getStudentSummaryLD.notes.content ||
    'The student did not take notes during this activity') + "\n        ")])])] : (_vm.selected_tab === 'feedback') ? [_c('div', [_c('live-discussion-points-bar', {
    staticClass: "col-xs-12 center mb3",
    staticStyle: {
      "max-width": "400px"
    },
    attrs: {
      "is_summary": true,
      "participation": _vm.participation
    },
    on: {
      "saveAssessment": _vm.saveAssessment
    }
  }), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse) ? _c('div', {
    staticClass: "content-card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pl-body-1 white-spaced-text"
  }, [_vm._v("\n            " + _vm._s(_vm.getStudentSummaryLD.observations[0] ||
    'You did not take any notes on this student') + "\n          ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-card"
  }, [_c('div', {
    staticClass: "pl-subheading",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._v("\n            Nudges from teacher\n          ")]), _vm._v(" "), (!_vm.getStudentSummaryLD.nudges.length) ? _c('div', {
    staticClass: "pl-body-1"
  }, [_vm._v("\n            No nudges during this RoundTable\n          ")]) : _vm._l((_vm.getStudentSummaryLD.nudges), function(nudge, index) {
    return _c('div', {
      key: index,
      staticClass: "pl-body-1"
    }, [_vm._v("\n            " + _vm._s(nudge.message) + "\n          ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "content-card mv3"
  }, [_c('div', {
    staticClass: "pl-subheading row middle-xs between-xs",
    staticStyle: {
      "margin": "0px 0px 15px 0px"
    }
  }, [(_vm.hasTeacherPermissionsInCourse) ? _c('div', [_vm._v("\n              Feedback\n              "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("\n                (" + _vm._s(_vm.getStudentSummaryLD.user.name.split(' ')[0]) + " will see\n                this)\n              ")])]) : [_vm._v(" Feedback from your teacher ")], _vm._v(" "), (_vm.hasTeacherPermissionsInCourse) ? _c('a', {
    staticClass: "pl-caption clickable",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.editing_feedback = !_vm.editing_feedback
      }
    }
  }, [_vm._v("\n              edit\n            ")]) : _vm._e()], 2), _vm._v(" "), (!_vm.editing_feedback || !_vm.hasTeacherPermissionsInCourse) ? _c('div', {
    staticClass: "pl-body-1 white-spaced-text"
  }, [_vm._v("\n            " + _vm._s(_vm.feedback_for_student || 'There is currently no feedback here...') + "\n          ")]) : _c('text-box', {
    attrs: {
      "theme": "pl-secondary",
      "buttonTitle": "Submit",
      "placeholder": "Send Feedback to your student"
    },
    on: {
      "messageSent": _vm.handleSendFeedback
    },
    model: {
      value: (_vm.feedback_for_student),
      callback: function($$v) {
        _vm.feedback_for_student = $$v
      },
      expression: "feedback_for_student"
    }
  })], 1), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "suggested-saved-div",
    on: {
      "click": function($event) {
        _vm.collapsed_saved_feedback = !_vm.collapsed_saved_feedback;
        _vm.collapsed_suggested_feedback = true;
      }
    }
  }, [_c('span', [_vm._v("\n                " + _vm._s(_vm.saved_feedback_collapse_message) + "\n              ")]), _vm._v(" "), (_vm.collapsed_saved_feedback) ? _c('i', {
    staticClass: "fas fa-arrow-down fa-xs"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up fa-xs"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "suggested-feedback-div",
    on: {
      "click": function($event) {
        _vm.collapsed_suggested_feedback = !_vm.collapsed_suggested_feedback;
        _vm.collapsed_saved_feedback = true;
      }
    }
  }, [_c('span', [_vm._v("\n                " + _vm._s(_vm.suggested_feedback_collapse_message) + "\n              ")]), _vm._v(" "), (_vm.collapsed_suggested_feedback) ? _c('i', {
    staticClass: "fas fa-arrow-down fa-xs"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up fa-xs"
  })])]), _vm._v(" "), (!_vm.collapsed_saved_feedback) ? _c('div', {
    staticClass: "col-xs mt4"
  }, [_c('div', {
    staticClass: "pl-subheading mb4"
  }, [_c('div', {
    staticClass: "center-xs b"
  }, [_vm._v("Saved Feedback")]), _vm._v(" "), _c('div', {
    staticClass: "start-xs nt4"
  }, [_c('pl-button', {
    staticClass: "pl-white justify-center",
    staticStyle: {
      "margin": "6px 0",
      "line-height": "25px",
      "min-height": "25px",
      "min-width": "60px",
      "border-radius": "5px"
    },
    nativeOn: {
      "click": function($event) {
        _vm.show_saved_feedback_modal = true
      }
    }
  }, [_c('img', {
    staticClass: "create-new-image",
    attrs: {
      "src": "/static/course_assets/create_new_plus_sign.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "f7"
  }, [_vm._v("New")])]), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-white",
    staticStyle: {
      "line-height": "25px",
      "min-height": "25px",
      "min-width": "60px",
      "border-radius": "5px"
    },
    nativeOn: {
      "click": function($event) {
        _vm.show_import_feedback_modal = true
      }
    }
  }, [_c('span', {
    staticClass: "f7"
  }, [_vm._v("Import")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "end-xs nt4 pl-body-1 clickable",
    on: {
      "click": _vm.refreshSavedFeedback
    }
  }, [_vm._v("\n                refresh\n              ")])]), _vm._v(" "), (_vm.saved_feedback_to_display.length) ? _c('div', _vm._l((_vm.saved_feedback_to_display), function(feedback, index) {
    return _c('div', {
      key: index,
      staticClass: "row middle-xs no-padding mb4"
    }, [_c('div', {
      staticClass: "no-padding no-margin col-xs-2"
    }, [_c('pl-button', {
      staticClass: "pl-icon pl-fog",
      nativeOn: {
        "click": function($event) {
          return _vm.selectSavedFeedback(feedback)
        }
      }
    }, [_c('span', {
      staticClass: "pl-title",
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("\n                      +\n                    ")])])], 1), _vm._v(" "), _c('div', {
      staticClass: "no-padding no-margin col-xs-10 tl"
    }, [_vm._v("\n                  " + _vm._s(feedback.text) + "\n                  "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "pl-caption clickable",
      on: {
        "click": function($event) {
          return _vm.editSavedFeedback(feedback)
        }
      }
    }, [_vm._v("\n                    Edit\n                  ")]), _vm._v(" "), _c('span', {
      staticClass: "ruby pl-caption clickable",
      on: {
        "click": function($event) {
          return _vm.deleteSavedFeedback(feedback)
        }
      }
    }, [_vm._v("\n                    Delete\n                  ")])])])
  }), 0) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs tc mb4"
  }, [_vm._v("\n                You have no saved feedback templates. Create a new template or\n                import some from an existing course.\n              ")])])]) : _vm._e(), _vm._v(" "), _c('div', [(!_vm.collapsed_suggested_feedback) ? _c('div', {
    staticClass: "mt4"
  }, [_c('div', {
    staticClass: "pl-subheading mb4 center-xs",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("\n                Suggested Feedback\n                "), _c('span', {
    staticClass: "pl-primary clickable pl-body-1",
    staticStyle: {
      "position": "absolute",
      "right": "0px"
    },
    on: {
      "click": _vm.refreshAutomatedFeedback
    }
  }, [_vm._v("\n                  refresh\n                ")])]), _vm._v(" "), _vm._l((_vm.automated_feedback_to_display), function(feedback, index) {
    return _c('div', {
      key: index,
      staticClass: "row middle-xs no-padding",
      staticStyle: {
        "margin": "0 0 30px 0"
      }
    }, [_c('div', {
      staticClass: "no-padding no-margin col-xs-2"
    }, [_c('pl-button', {
      staticClass: "pl-icon pl-fog",
      nativeOn: {
        "click": function($event) {
          return _vm.selectAutomatedFeedback(feedback)
        }
      }
    }, [_c('span', {
      staticClass: "pl-title",
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("\n                      +\n                    ")])])], 1), _vm._v(" "), _c('div', {
      staticClass: "no-padding no-margin col-xs-10 tl"
    }, [_vm._v("\n                  " + _vm._s(feedback.text) + "\n                  "), _c('br'), _vm._v(" "), _c('span', {
      directives: [{
        name: "my-tooltip",
        rawName: "v-my-tooltip",
        value: (feedback.explanation),
        expression: "feedback.explanation"
      }],
      staticClass: "ruby pl-caption"
    }, [_vm._v("\n                    Why this suggestion?\n                  ")])])])
  })], 2) : _vm._e()])]) : _vm._e()], 1)] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.show_saved_feedback_modal) ? _c('saved-feedback-modal', {
    attrs: {
      "feedbackID": _vm.feedback_id,
      "feedbackContent": _vm.feedback_content,
      "focusOnMounted": true,
      "isEditFeedback": _vm.set_edit_saved_feedback,
      "rtType": 'live'
    },
    on: {
      "modalFeedbackClosed": _vm.closeFeedbackModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_import_feedback_modal) ? _c('import-saved-feedback-modal', {
    attrs: {
      "onlineRT": false
    },
    on: {
      "modalFeedbackClosed": function($event) {
        _vm.show_import_feedback_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_confirm_delete_feedback) ? _c('pl-confirm', {
    attrs: {
      "confirmColor": "bg-red-500",
      "confirmText": "DELETE",
      "message": "Delete this saved feedback template?"
    },
    on: {
      "close": function($event) {
        _vm.show_confirm_delete_feedback = false
      },
      "confirm": _vm.confirmDeleteSavedFeedback
    }
  }, [_c('div', {
    staticClass: "mh4 mb4 tc ph4 pl-subheading"
  }, [_c('p', {
    staticClass: "pl-body-1 ma0 italics"
  }, [_vm._v("\n        It will be permanently removed from this course.\n      ")])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pl-subheading",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._v("\n            My observations\n            "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("(private)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-6a61c9a2!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/measureLiveDiscussion/individualStudentLDSummary.vue
// module id = 1687
// module chunks = 61